import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "AccountingImportListPage" */
	'pages/Invoice/AccountingImport/AccountingImportListPage'));

export default [{ component, exact: true, path: '/accounting_imports' }];
